/**
 * Created by WorkAxis www.workaxis.in
 * Contact page.
 */
import React from 'react';
import "./style.css";
import ContactForm from "./ContactForm";

export default function Contact() {
    return (
        <div className="wx-contact-hero">
            <div className="wx-container">
                <div className="wx-section-head">
                    <div className="wx-kicker">Contact</div>
                    <h1 className="wx-h2">What are you trying to automate or build?</h1>
                    <p className="wx-lead">Describe your workflow or product idea — we usually respond within one business day.</p>
                </div>
                <div className="wx-contact-grid">
                    <div className="wx-contact-info">
                        <div className="wx-contact-line">
                            <div className="wx-contact-line-label">Email</div>
                            <a href="mailto:hello@workaxis.in">hello@workaxis.in</a>
                        </div>
                        <div className="wx-contact-line">
                            <div className="wx-contact-line-label">Phone</div>
                            <a href="tel:+918754533683">(+91) 87545 33683</a>
                        </div>
                        <div className="wx-contact-line">
                            <div className="wx-contact-line-label">Address</div>
                            <a href="https://maps.google.com/?q=WORKAXIS+PRIVATE+LIMITED+Chennai" target="_blank"
                               rel="noreferrer">
                                Sivanandha Street, Vellakkal,<br/>Chennai, Tamil Nadu 600117
                            </a>
                        </div>
                    </div>
                    <iframe className="wx-contact-map"
                            title="WorkAxis office location"
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15554.421536301019!2d80.18009!3d12.9330654!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd2053fbd8d930bc4!2sWORKAXIS%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1661154955989!5m2!1sen!2sin"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div className="wx-contact-widget">
                    <div className="wx-form-card">
                        <div className="wx-form-card-head">
                            <h2 className="wx-h2">Tell us about your workflow or product.</h2>
                            <p className="wx-lead">Fill in the form and it lands straight in our CRM —
                                we'll be in touch shortly.</p>
                        </div>
                        <ContactForm/>
                    </div>
                </div>
            </div>
        </div>
    );
}
